import { useEffect, useRef } from 'react'

const useSignInHandler = () => {
  const reloadRequestedRef = useRef(false)
  useEffect(() => {
    if (window.location.pathname === '/sign-in' && !reloadRequestedRef.current) {
      reloadRequestedRef.current = true
      window.location.reload()
    }
  }, [window.location.pathname])
}

export default useSignInHandler
